export const SOCIAL_AUTH_CALLBACK_KEY = '__DW_SOCIAL_AUTH_CALLBACK__';
export const SOCIAL_AUTH_CALLBACK_PARAM = 'dwAuthCb';
function getBrowserOrigin() {
    return typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
}
export function setSocialAuthCallbackMarker(marker) {
    try {
        if (typeof window === 'undefined')
            return;
        window.sessionStorage.setItem(SOCIAL_AUTH_CALLBACK_KEY, marker);
    }
    catch {
        // ignore storage failures
    }
}
export function consumeSocialAuthCallbackMarker() {
    try {
        if (typeof window === 'undefined')
            return null;
        const value = window.sessionStorage.getItem(SOCIAL_AUTH_CALLBACK_KEY);
        window.sessionStorage.removeItem(SOCIAL_AUTH_CALLBACK_KEY);
        return value;
    }
    catch {
        return null;
    }
}
export function appendSocialAuthCallbackMarker(callbackReturnTo, marker) {
    try {
        const callbackUrl = new URL(callbackReturnTo, getBrowserOrigin());
        callbackUrl.searchParams.set(SOCIAL_AUTH_CALLBACK_PARAM, marker);
        return callbackUrl.toString();
    }
    catch {
        return callbackReturnTo;
    }
}
export function resolveSocialAuthCallbackMarker(search) {
    try {
        const params = new URLSearchParams(search);
        const directMarker = params.get(SOCIAL_AUTH_CALLBACK_PARAM);
        if (directMarker)
            return directMarker;
        const nestedReturnTo = params.get('returnTo');
        if (!nestedReturnTo)
            return null;
        const callbackUrl = new URL(nestedReturnTo, getBrowserOrigin());
        return callbackUrl.searchParams.get(SOCIAL_AUTH_CALLBACK_PARAM);
    }
    catch {
        return null;
    }
}
export function readSocialAuthCallbackMarker() {
    try {
        if (typeof window === 'undefined')
            return null;
        return window.sessionStorage.getItem(SOCIAL_AUTH_CALLBACK_KEY);
    }
    catch {
        return null;
    }
}
/**
 * True only when the callback marker in the URL matches the per-tab marker this
 * tab stored before redirecting out for SSO. A bare `dwAuthCb` query parameter
 * is attacker-suppliable and is not sufficient to resume a cookie session.
 */
export function isVerifiedSocialAuthCallbackReturn(search) {
    const fromUrl = resolveSocialAuthCallbackMarker(search);
    if (!fromUrl)
        return false;
    const fromSession = readSocialAuthCallbackMarker();
    return fromSession !== null && fromSession === fromUrl;
}
export function consumeVerifiedSocialAuthCallbackMarker(search) {
    const fromUrl = resolveSocialAuthCallbackMarker(search);
    if (!fromUrl)
        return null;
    try {
        if (typeof window === 'undefined')
            return null;
        const fromSession = window.sessionStorage.getItem(SOCIAL_AUTH_CALLBACK_KEY);
        if (fromSession !== fromUrl)
            return null;
        window.sessionStorage.removeItem(SOCIAL_AUTH_CALLBACK_KEY);
        return fromSession;
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=social-auth-callback.js.map